module.exports = __webpack_public_path__ + "static/media/Postales-11.913a5900.png";